/** @type {import('tailwindcss').Config} */
// import * as nesting from 'tailwindcss/nesting'
module.exports = {
  content: [
    "./src/**/*.{html,ts}",
  ],
  theme: {
    screens: {
      'sm': '640px',
      'md': '768px',
      'lg': '900px',
      'xl': '1024px',
      '2xl': '1280px',
      '3xl': '1536px',

      //Max Width
      'lt-sm': { 'max': '640px' },
      'lt-md': { 'max': '768px' },
      'lt-lg': { 'max': '900px' },
      'lt-xl': { 'max': '1024px' },
      'lt-2xl': { 'max': '1280px' },
      'lt-3xl': { 'max': '1536px' },
    },
    extend: {
      colors: {
        yc: {
          global: {
            neutral: {
              white: 'var(--global-neutral-white)',
              gray: {
                100: 'var(--global-neutral-gray100)',
                200: 'var(--global-neutral-gray200)',
                300: 'var(--global-neutral-gray300)',
                400: 'var(--global-neutral-gray400)',
                500: 'var(--global-neutral-gray500)',
                600: 'var(--global-neutral-gray600)',
                800: 'var(--global-neutral-gray800)',
                900: 'var(--global-neutral-gray900)',
              },
            },
            primary: {
              blue: {
                50: 'var(--global-primary-blue50)',
                100: 'var(--global-primary-blue100)',
                200: 'var(--global-primary-blue200)',
                300: 'var(--global-primary-blue300)',
                400: 'var(--global-primary-blue400)',
                500: 'var(--global-primary-blue500)',
                600: 'var(--global-primary-blue600)',
                700: 'var(--global-primary-blue700)',
                800: 'var(--global-primary-blue800)',
                900: 'var(--global-primary-blue900)',
              },
            },
            secondary: {
              bluedark: {
                50: 'var(--global-secondary-bluedark50)',
                100: 'var(--global-secondary-bluedark100)',
                200: 'var(--global-secondary-bluedark200)',
                300: 'var(--global-secondary-bluedark300)',
                400: 'var(--global-secondary-bluedark400)',
                500: 'var(--global-secondary-bluedark500)',
                600: 'var(--global-secondary-bluedark600)',
                700: 'var(--global-secondary-bluedark700)',
                800: 'var(--global-secondary-bluedark800)',
                900: 'var(--global-secondary-bluedark900)',
              },
            },
            accent: {
              blue: {
                50: 'var(--global-accent-blueAcc50)',
                700: 'var(--global-accent-blueAcc700)',
              },
              yellow: {
                50: 'var(--global-accent-yellowAcc50)',
                700: 'var(--global-accent-yellowAcc700)',
              },
              red: {
                50: 'var(--global-accent-redAcc50)',
                700: 'var(--global-accent-redAcc700)',
                800: 'var(--global-accent-redAcc800)',
                900: 'var(--global-accent-redAcc900)',
              },
              green: {
                50: 'var(--global-accent-greenAcc50)',
                700: 'var(--global-accent-greenAcc700)',
                800: 'var(--global-accent-greenAcc800)',
                900: 'var(--global-accent-greenAcc900)',
              },
            },
            alternative: {
              blue: {
                50: 'var(--global-alternative-blueAlt50)',
                700: 'var(--global-alternative-blueAlt700)',
              },
              turquoise: {
                50: 'var(--global-alternative-turquoiseAlt50)',
                700: 'var(--global-alternative-turquoiseAlt700)',
              },
              red: {
                50: 'var(--global-alternative-redAlt50)',
                700: 'var(--global-alternative-redAlt700)',
              },
              yellow: {
                50: 'var(--global-alternative-yellowAlt50)',
                700: 'var(--global-alternative-yellowAlt700)',
              },
              purple: {
                50: 'var(--global-alternative-purpleAlt50)',
                700: 'var(--global-alternative-purpleAlt700)',
              },
              green: {
                50: 'var(--global-alternative-greenAlt50)',
                700: 'var(--global-alternative-greenAlt700)',
              },
              orange: {
                50: 'var(--global-alternative-orangeAlt50)',
                700: 'var(--global-alternative-orangeAlt700)',
              },
            },
            gradient: {
              50: 'var(--global-gradient-gradient1)',
              700: 'var(--global-gradient-gradient2)',
            },
          },
          background: {
            core: 'var(--background-core)',
            default: 'var(--background-default)',
            neutral: 'var(--background-neutral)',
            avatar: 'var(--background-avatar)',
            productimg: 'var(--background-product-img)',
            dark: 'var(--background-dark)',
            tabletop: 'var(--background-table-top)',
            overlay: 'var(--background-overlay)',
            alert: {
              info: 'var(--background-alert-info)',
              warning: 'var(--background-alert-warning)',
              error: 'var(--background-alert-error)',
              success: 'var(--background-alert-success)',
            },
            action: {
              selected: 'var(--background-action-selected)',
              hover: 'var(--background-action-hover)',
              disabled: 'var(--background-action-disabled)',
            },
            decorative: {
              gray: 'var(--background-decorative-gray)',
              blue: 'var(--background-decorative-blue)',
              yellow: 'var(--background-decorative-yellow)',
              red: 'var(--background-decorative-red)',
              green: 'var(--background-decorative-green)',
            },
          },
          border: {
            input: {
              default: 'var(--border-input-default)',
              hover: 'var(--border-input-hover)',
              focused: 'var(--border-input-focused)',
              filled: 'var(--border-input-filled)',
              disabled: 'var(--border-input-disabled)',
              error: 'var(--border-input-error)',
            },
            default: 'var(--border-default)',
            Selected: 'var(--border-selected)',
            alert: {
              info: 'var(--border-alert-info)',
              warning: 'var(--border-alert-warning)',
              success: 'var(--border-alert-success)',
              error: 'var(--border-alert-error)',
            }
          },
          icon: {
            primary: 'var(--icon-primary)',
            secondary: 'var(--icon-secondary)',
            default: 'var(--icon-default)',
            disabled: 'var(--icon-disabled)',
            oncolor: 'var(--icon-on-color)',
            info: 'var(--icon-info)',
            warning: 'var(--icon-warning)',
            success: 'var(--icon-success)',
            error: 'var(--icon-error)',
          },
          btn: {
            primary: {
              default: 'var(--bg-cta-primary-default)',
              hover: 'var(--bg-cta-primary-hover)',
              focused: {
                bg: 'var(--bg-cta-primary-focused)',
                st: 'var(--st-cta-primary-focused)',
              },
              pressed: {
                bg: 'var(--bg-cta-primary-pressed)',
                st: 'var(--st-cta-primary-pressed)',
              },
              disabled: 'var(--bg-cta-primary-disabled)',
            },
            secondary: {
              default: {
                st: 'var(--st-cta-secondary-default)',
              },
              hover: 'var(--bg-cta-secondary-hover)',
              focused: {
                bg: 'var(--bg-cta-secondary-focused)',
                st: 'var(--st-cta-secondary-focused)',
              },
              pressed: {
                bg: 'var(--bg-cta-secondary-pressed)',
                st: 'var(--st-cta-secondary-pressed)',
              },
              disabled: 'var(--st-cta-secondary-disabled)',
            },
            tertiary: {
              default: 'var(--bg-cta-tertiary-default)',
              hover: 'var(--bg-cta-tertiary-hover)',
              focused: {
                bg: 'var(--bg-cta-tertiary-focused)',
                st: 'var(--st-cta-tertiary-focused)',
              },
              pressed: {
                bg: 'var(--bg-cta-tertiary-pressed)',
                st: 'var(--st-cta-tertiary-pressed)',
              },
              disabled: {
                st: 'var(--st-cta-tertiary-disabled)',
              },
            },
            icon: {
              default: 'var(--bg-cta-icon-default)',
              hover: 'var(--bg-cta-icon-hover)',
              focused: {
                bg: 'var(--bg-cta-icon-focused)',
                st: 'var(--st-cta-icon-focused)',
              },
              pressed: 'var(--bg-cta-icon-pressed)',
              disabled: {
                st: 'var(--st-cta-icon-disabled)',
              },
            },
            success: {
              default: 'var(--bg-cta-success-default)',
              hover: 'var(--bg-cta-success-hover)',
              focused: {
                bg: 'var(--bg-cta-success-focused)',
                st: 'var(--st-cta-success-focused)',
              },
              pressed: 'var(--bg-cta-success-pressed)',
              disabled: 'var(--bg-cta-success-disabled)',
            },
            danger: {
              default: 'var(--bg-cta-success-default)',
              hover: 'var(--bg-cta-success-hover)',
              focused: {
                bg: 'var(--bg-cta-success-focused)',
                st: 'var(--st-cta-success-focused)',
              },
              pressed: 'var(--bg-cta-success-pressed)',
              disabled: 'var(--bg-cta-success-disabled)',
            },
          },
          shape: {
            recibido: 'var(--shape-recibido)',
            progreso: 'var(--shape-progreso)',
            completado: 'var(--shape-completado)',
            cancelado: 'var(--shape-cancelado)',
          },
          text: {
            link: {
              default: 'var(--link-text-default)',
              hover: 'var(--link-text-hover)',
              toast: 'var(--link-text-toast)',
              oncolor: 'var(--link-text-on-color)',
            },
            primary: 'var(--text-primary)',
            secondary: 'var(--text-secondary)',
            tertiary: 'var(--text-tertiary)',
            disabled: 'var(--text-disabled)',
            inverse: 'var(--text-inverse)',
            interactive: {
              default: 'var(--text-interactive-default)',
            },
            accent: {
              primary: 'var(--text-accent-primary)',
              success: 'var(--text-accent-success)',
              error: 'var(--text-accent-error)',
            },
            label: 'var(--text-label)',
            helper: 'var(--text-helper)',
            placeholder: {
              default: 'var(--text-placeholder-default)',
              filled: 'var(--text-placeholder-filled)',
            }
          },
          alt: {
            blue: {
              50: 'var(--alt-blue-50)',
              700: 'var(--alt-blue-700)',
            },
            purple: {
              50: 'var(--alt-purple-50)',
              700: 'var(--alt-purple-700)',
            },
            turquoise: {
              50: 'var(--alt-turquoise-50)',
              700: 'var(--alt-turquoise-700)',
            },
            green: {
              50: 'var(--alt-green-50)',
              700: 'var(--alt-green-700)',
            },
            red: {
              50: 'var(--alt-red-50)',
              700: 'var(--alt-red-700)',
            },
            orange: {
              50: 'var(--alt-orange-50)',
              700: 'var(--alt-orange-700)',
            },
            yellow: {
              50: 'var(--alt-yellow-50)',
              700: 'var(--alt-yellow-700)',
            },
          },
        },
      },
      screens: {
        print: { raw: 'print' },
        screen: { raw: 'screen' },
      },
    },
  },
  corePlugins: {
    preflight: false
  },
  plugins: [],
}